<script setup lang="ts">
import { resolveComponent } from 'vue';
import { THEME } from '@pkg/config/misc/theme';
import type { CmsIconName } from '@pkg/cms-icons';
import { useResolvedSectionTheme } from '@pkg/modular-blocks/frontend/useResolvedSectionTheme';
import MarketplaceSolutionFinder from './MarketplaceSolutionFinder.vue';

const props = defineProps<{
  theme: THEME;
  vendorTypes: Array<{
    _id: string;
    title: string;
    icon: CmsIconName;
  }>;
  stepOneTitle?: string;
  stepTwoTitle?: string;
  changeButtonText?: string;
  countryFieldTitle?: string;
  postcodeFieldTitle?: string;
  submitButtonText?: string;
}>();

/** Host app registers PartialSection. */
const PartialSection = resolveComponent('PartialSection');

const resolvedTheme = useResolvedSectionTheme(() => props.theme);
</script>

<template>
  <component :is="PartialSection" :theme="resolvedTheme || THEME.DARK">
    <MarketplaceSolutionFinder v-bind="props" />
  </component>
</template>
